export default class {
    constructor(options) {
        const defaults = {
            el: '[data-share]',
            dom: {
                button: '[data-share-button]',
            }
        };
        this.options = $.extend(true, {}, defaults, options);
        this.$window = $(window);
        this.$document = $(document);
        return this;
    }

    bindShareEvents() {
        $(this.options.el).each((i, el) => {
            const $el = $(el);
        const code = encodeURIComponent($el.attr('data-code'));
        const url = encodeURIComponent($el.attr('data-url'));
        const title = encodeURIComponent($el.attr('data-title'));
        const summary = encodeURIComponent($el.attr('data-summary'));
        const image = encodeURIComponent($el.attr('data-image'));
        const vkPopupUrl = `https://vk.com/share.php?url=${url}/?title=${title}&image=${image}`;
        const fbPopupUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        //const fbPopupUrl = `http://www.facebook.com/sharer.php?s=100&p[url]=${url}&p[title]=${title}&p[summary]=${summary}&p[images][0]=${image}`;

            
        console.log(url);

        $(this.options.dom.button, $el).each((i, button) => {
            const $button = $(button);

        switch ($button.data('share-button')) {
            case 'fb':
                $button.attr('href', fbPopupUrl);
                break;
            case 'vk':
                $button.attr('href', vkPopupUrl);
                break;
        }
    });
    });
    }
    render() {
        this.bindShareEvents();
        this.$window.on('share.bindEvents', this.bindShareEvents.bind(this));
    }
}



// WEBPACK FOOTER //
// ./_src/js/modules/share.js